import { NotificationService } from 'src/app/shared/services/notification-service/notification.service';
import { ReportingService } from 'src/app/shared/services/reporting-service/reporting.service';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-locality-map',
  templateUrl: './locality-map.component.html',
  styleUrls: ['./locality-map.component.scss', '../../../../../../../../css/2-modules/_admin-portal.scss']
})
export class LocalityMapComponent implements OnInit {

  @Input() localityMapFileId: string;
  @Output() setLocalityMapFileId = new EventEmitter<string>();

  file: any;
  fileUrl: string = null;
  hideButtons = false;

  constructor(
    private reportingService: ReportingService,
    private notificationService: NotificationService
  ) { }

  ngOnInit(): void {
    this.loadFile();
  }

  async setFile(event: { target: { files: any[]; }; }) {
    try {
      this.localityMapFileId = await this.reportingService.uploadFile(event.target.files[0]);
      this.setLocalityMapFileId.emit(this.localityMapFileId);
      this.file = event.target.files[0];

      var reader = new FileReader();

      reader.onload = (event: any) => {
        this.fileUrl = event.target.result;
        this.hideButtons = true;
      }

      reader.readAsDataURL(this.file);
    }
    catch (error) {
      this.notificationService.showErrorMessage('Error', 'Could not upload file.');
    }
  }

  replace() {
    this.fileUrl = null;
    this.hideButtons = false;
  }

  async loadFile() {
    if (this.localityMapFileId) {
      try {
        const fileUrl = await this.reportingService.getFileUrl(this.localityMapFileId);
        this.fileUrl = fileUrl;
        this.hideButtons = !!fileUrl;
      } catch (error) {
        this.notificationService.showErrorMessage('Error', 'Could not load file.');
      }
    }
  }
}
